import {dataFetcher} from "../../services/dataGuetter/dataFetcher";

export async function getAllLieux():Promise<Lieu[]>{
    const res:any = await dataFetcher(`lieus`, {method:'get'});
    return res["hydra:member"];
}